import { render, staticRenderFns, recyclableRender, components } from "./shop_list.vue?vue&type=template&id=3c5213b2&"
var renderjs
import script from "./shop_list.vue?vue&type=script&lang=js&"
export * from "./shop_list.vue?vue&type=script&lang=js&"
import style0 from "./shop_list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/shop/shop_list.vue"
export default component.exports